import { combineReducers } from 'redux';
import formData from 'store/reducers/lodgingOption/getFormData';
import addLodgingOption from 'store/reducers/lodgingOption/add';
import viewLodgingOption from 'store/reducers/lodgingOption/view';
import editLodgingOption from 'store/reducers/lodgingOption/edit';
import getLodgings from 'store/reducers/lodgingOption/get';
import deleteLodgingOption from 'store/reducers/lodgingOption/delete';
import searchReservation from 'store/reducers/lodgingOption/searchReservation';
import locationMatches from 'store/reducers/lodgingOption/locationMatches';
import massAdd from 'store/reducers/lodgingOption/massAdd';
import exportExcel from 'store/reducers/lodgingOption/exportExcel';
import getActivityLogs from 'store/reducers/lodgingOption/get-activity-logs';
import locationMatchesForMassBooking from 'store/reducers/lodgingOption/location-matches-for-mass-booking';
import getLocationMatchesByRequest from 'store/reducers/lodgingOption/get-location-matches-by-request';
import getAddressesForFilter from 'store/reducers/lodgingOption/get-addresses-for-filter';
import getTypesForFilter from 'store/reducers/lodgingOption/get-types-for-filter';
import lodgingTableFilters from 'store/reducers/lodgingOption/lodging-table-filters';
import { mergeLodgingOptions } from 'store/actions/lodgingOption';
import getReportExcel from "store/reducers/room/getReportExcel";
import GetLodgingsCount from 'store/reducers/lodgingOption/get-count';

export default combineReducers({
  formData,
  get: getLodgings,
  getCount: GetLodgingsCount,
  add: addLodgingOption,
  view: viewLodgingOption,
  edit: editLodgingOption,
  delete: deleteLodgingOption,
  searchReservation,
  locationMatches,
  exportExcel,
  massAdd,
  getActivityLogs,
  locationMatchesForMassBooking,
  getLocationMatchesByRequest,
  getAddressesForFilter,
  getTypesForFilter,
  lodgingTableFilters,
  mergeLodgingOption: mergeLodgingOptions,
  getReportExcel,
});